import {
    BareFetcher,
    PublicConfiguration,
    Revalidator,
    RevalidatorOptions,
} from "swr/dist/_internal";
import { KnownAppSDK } from "@contentful/app-sdk";

const BASE_DELAY = 200;
const JITTER_FACTOR = 4;

export const handleSwrRetry =
    (sdk: KnownAppSDK) =>
    (
        error: Error,
        key: string,
        config: Readonly<PublicConfiguration<any, any, BareFetcher<any>>>,
        revalidate: Revalidator,
        { retryCount }: Required<RevalidatorOptions>
    ) => {
        if (retryCount >= 5) {
            sdk.notifier.error(error.message ?? "Error fetching from DeepL");
            return;
        }

        const jitter = Math.random() * BASE_DELAY * JITTER_FACTOR;
        const delay = BASE_DELAY * Math.pow(2, retryCount) + jitter;

        setTimeout(() => revalidate({ retryCount }), delay);
    };
